import { render } from "./EnrollmentCollectionContent.vue?vue&type=template&id=4c7d42ab&ts=true"
import script from "./EnrollmentCollectionContent.vue?vue&type=script&lang=ts"
export * from "./EnrollmentCollectionContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__